module.exports = __webpack_public_path__ + "media/images/budget-advocacy-cf680ad02e80fb39eead08e248b1481f.jpeg";